import { render, staticRenderFns } from "./AstralFSN.vue?vue&type=template&id=0afd1d77&scoped=true&"
import script from "./AstralFSN.vue?vue&type=script&lang=js&"
export * from "./AstralFSN.vue?vue&type=script&lang=js&"
import style0 from "./AstralFSN.vue?vue&type=style&index=0&id=0afd1d77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afd1d77",
  null
  
)

export default component.exports